import { Label as RadixLabel } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

export const Label = ({ className, ...props }: ComponentProps<typeof RadixLabel.Root>) => (
  <RadixLabel.Root className={cn("text-sm font-medium text-text", className)} {...props} />
);
